import React from 'react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { FCWithChildren } from '@wix/challenges-web-library';

import { MemberChallenge } from '@wix/ambassador-challenges-v1-challenge/types';
import { State as ParticipantState } from '@wix/ambassador-challenges-v1-participant/types';
import {
  isUserInPaymentState,
  isUserJoinedAlready,
} from '../../../../contexts/User/helpers/userTypeHandlers';
import { useLeaveChallengeModal } from '../../../../contexts/LeaveChallengeModal/LeaveChallengeModalContext';
import { useUser } from '../../../../contexts/User/UserContext';
import { classes } from './ChallengeItem.st.css';
import { useMemberPaidPlans } from '../../../../contexts/storage-contexts/PaidPlans';
import { getPricingViewOptions } from '../../../../services/getPricingViewOptions';

export interface ILeaveChallengeButton {
  challenge: MemberChallenge;
  onChallengeRemove(challengeId: string): void;
}

export const LeaveChallengeButton: FCWithChildren<ILeaveChallengeButton> = (
  props,
) => {
  const { t } = useTranslation();
  const { cancelJoinRequest } = useUser();
  const { showModal } = useLeaveChallengeModal();

  const isInvited =
    (props.challenge.summary?.participation?.state as any) ===
    ParticipantState.INVITED;
  const isRequested =
    (props.challenge.summary?.participation?.state as any) ===
    ParticipantState.JOIN_REQUESTED;
  const isJoined = isUserJoinedAlready(
    props.challenge.summary?.participation?.state as any,
  );
  const ppCtx = useMemberPaidPlans();
  const { isFree } = getPricingViewOptions(
    props.challenge.challenge,
    ppCtx.userPaidPlans,
  );
  if (
    isInvited ||
    isUserInPaymentState(props.challenge.summary?.participation?.state as any)
  ) {
    return null;
  }

  return (
    <>
      <button
        className={`${classes.link} ${classes.leaveChallengeButton}`}
        onClick={async () => {
          const programId = props.challenge.challenge.id;
          if (isJoined) {
            showModal(
              {
                challengeId: programId,
                participantId:
                  props.challenge?.summary?.participation?.participantId,
                isPaidChallenge: !isFree,
              },
              () => {},
              () => {
                props.onChallengeRemove(programId);
              },
            );
          } else {
            props.onChallengeRemove(programId);
            await cancelJoinRequest(programId);
          }
        }}
      >
        {isJoined && t('members-area.cta.leave-challenge')}
        {isRequested && t('members-area.cta.cancel-request')}
      </button>
    </>
  );
};
